export default __webpack_public_path__ + "static/media/sydeclassprofile.12ffadc8.gif";